import styled from 'styled-components';
import { StyleColor, navBarButtonWrapperStyle, navBarIconStyle, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface StyledDriveItemSelectionIconProps {
	isCard: boolean;
	isInSelection: boolean;
	fillColor: string;
	strokeColor: string;
	isCoverFlow: boolean;
	isRowView?: boolean;
	needBottomPadding?: boolean;
}

const StyledDriveItemSelectionIcon = styled('span')`
	${navBarButtonWrapperStyle};
	margin: 0;
	${ (props: StyledDriveItemSelectionIconProps) => props.isCard &&
		`position: absolute;`
	}
	${ (props: StyledDriveItemSelectionIconProps) => props.isRowView
		? `bottom: 8px;
		left: 8px;`
		: `bottom: 15px;
		left: 15px;`
	}

	& > svg {
		${navBarIconStyle}
		padding-bottom: ${(props: StyledDriveItemSelectionIconProps) => props.needBottomPadding ? '4px' : '0px'};

		fill: ${ (props: StyledDriveItemSelectionIconProps) => props.isInSelection
			? `${hexToRgba(props.fillColor, 80)}!important`
			: `${hexToRgba(props.fillColor, 80)}`
		};

		stroke: ${hexToRgba(StyleColor.Black, 40)};
		stroke-width: 1px;
	}
`;

const SelectionClearerButton = styled('div')`
	cursor: pointer;
	font-size: 13px;
	font-weight: 400;
	letter-spacing: 1.2px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	white-space: nowrap;
`;

export {
	StyledDriveItemSelectionIconProps,
	StyledDriveItemSelectionIcon,
	SelectionClearerButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Selection/Toggler/styles.ts